import BaseFeature from '../../foundation/base/base';

class Search extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;


		this.submitButton = this.el.querySelector('[data-ref="search__button"]');
		this.searchPanel = document.querySelector('.o-search__panel');
		this.searchOpen = this.el.querySelector('[data-js="searchOpen"]');
		this.searchClose = this.el.querySelector('[data-js="searchClose"]');
		this.searchBox = this.el.querySelector('[data-js="searchBox"]');
		this.searchInputs = document.getElementsByTagName('input');
		this.searchInput = this.el.querySelector('[data-ref="search__input"]');

		this.addEventListener();
		this.checkSearchButton();
		this.searchParameter();

		this.log('Search');
	}

	addEventListener() {
		this.dom.input.addEventListener('keyup', () => this.activateSearchButton());
		this.dom.open.addEventListener('click', () => this.openSearchPanel());
		this.dom.close.addEventListener('click', () => this.closeSearchPanel());

		window.addEventListener('keyup', (e) => {
			const SearchOpenIsFocused = document.activeElement === this.searchOpen;
			const SearchCloseIsFocused = document.activeElement === this.searchClose;
			if (SearchOpenIsFocused && e.code === 'Enter') {
				e.preventDefault();
				// Trigger the button element with a click
				this.searchOpen.click();
				this.searchClose.setAttribute('tabindex', '0');
				if (this.searchInput) {
					this.searchInput.classList.remove('mouse-focus');
				}
			}
			if (SearchCloseIsFocused && e.code === 'Enter') {
				e.preventDefault();
				// Trigger the button element with a click
				this.searchClose.click();
				this.searchClose.setAttribute('tabindex', '-1');
				this.searchOpen.focus();
				if (this.searchInput) {
					this.searchInput.classList.add('mouse-focus');
				}
			}
		});

		if (this.searchInputs) {
			for (let i = 0; i < this.searchInputs.length; i++) {
				const input = this.searchInputs[i];
				if (input.type === 'text' || input.type === 'number' || input.type === 'email' || input.type === 'tel' || input.type === 'date' || input.type === 'password') {
					input.classList.add('mouse-focus');

					input.addEventListener('keyup', (e) => {
						if (e.code === 'Tab') {
							input.classList.remove('mouse-focus');
						}
					});

					input.addEventListener('mousedown', () => {
						input.classList.add('mouse-focus');
					});
				}
			}
		}
	}

	openSearchPanel() {
		this.dom.open.classList.add('o-search__open--hidden');
		this.searchPanel.classList.add('o-search__panel--divider');
		setTimeout(() => {
			this.dom.input.focus();
		}, 100);
	}

	closeSearchPanel() {
		this.dom.open.classList.remove('o-search__open--hidden');
		this.searchPanel.classList.remove('o-search__panel--divider');
	}
	searchParameter() {	
		const customeUrl = this.submitButton.getAttribute('data-url');
		this.submitButton.addEventListener('click', (e) => {
			e.preventDefault(); // Prevent default form submission behavior

			const searchInputValue = this.searchInput.value; // Get the value from the input
			const url = new URL(customeUrl); // Concatenate the customeUrl
			
			// Set the search parameter with the new value
			url.searchParams.set('searchWord', searchInputValue);

			// Update the URL and load the page
			window.location.href = url.href;
		});
	}
	activateSearchButton() {
		if (this.dom.input.value.length > 1) {
			this.submitButton.classList.remove('m-link-icon--button-disabled');
			this.submitButton.removeAttribute('disabled');
			this.submitButton.setAttribute('tabindex', '0');
		}
		if (this.dom.input.value.length < 1) {
			this.submitButton.classList.add('m-link-icon--button-disabled');
			this.submitButton.setAttribute('disabled', 'disabled');
			this.submitButton.setAttribute('tabindex', '1');
		}
	}


	checkSearchButton() {
		if (this.submitButton && this.submitButton.classList.contains('m-link-icon--disabled')) {
			return false;
		}
		return true;
	}
}

export default Search;
